export default __webpack_public_path__ + "static/media/speak.cda52c7d.svg";